/**
 * Dynamic Meal Box CTA buttons
 * Updates button text and URL based on cart state
 */

(function() {
  'use strict';

  // Declare variables at the top to avoid TDZ issues
  let observer = null;
  let isUpdating = false;
  let lastCartCount = null;

  function updateMealBoxButtons() {
    // Set flag to prevent observer loop
    isUpdating = true;

    // Get current cart count
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const hasItems = cart.item_count > 0;
        const isPetMealsCollection = window.location.pathname.includes('/collections/pet-meals');
        const isProductPage = window.location.pathname.includes('/products/');
        const cartRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
        const isCartPage = window.location.pathname === cartRoot || window.location.pathname.startsWith(cartRoot + '/');
        const isDogFoodSampleBoxes = window.location.pathname.includes('/collections/dog-food-sample-boxes');
        const isLandingPage = isDogFoodSampleBoxes || isCartPage;

        // Disconnect observer temporarily to prevent loop
        if (observer) {
          observer.disconnect();
        }

        // Update cart count in header
        const countEls = document.querySelectorAll('.cart-link__bubble-num');
        countEls.forEach(el => {
          el.innerText = cart.item_count;
        });

        // Ensure cart bubble is always visible (orange background with count)
        const bubbles = document.querySelectorAll('.cart-link__bubble');
        bubbles.forEach(bubble => {
          bubble.classList.add('cart-link__bubble--visible');
        });

        // Update all meal box CTA buttons (EXCEPT those in cart drawer)
        const buttons = document.querySelectorAll('[data-meal-box-cta]');
        buttons.forEach(button => {
          // Never hide buttons inside the cart drawer
          const isDrawerButton = button.closest('.drawer') || button.classList.contains('cart__checkout--drawer');

          if (isDrawerButton) {
            // Cart drawer button should always be visible
            return;
          }

          if (isLandingPage || isPetMealsCollection || isProductPage || hasItems) {
            // Hide CTA on: landing pages, pet-meals, product pages, or when cart has items
            button.style.display = 'none';
          } else {
            // Show CTA on other pages when cart is empty
            button.style.display = '';
          }
        });

        // Update cart icon visibility
        const cartIcons = document.querySelectorAll('.site-nav__link--cart');
        cartIcons.forEach(icon => {
          if (isLandingPage) {
            // Hide on landing pages (cart page and dog-food-sample-boxes)
            icon.style.display = 'none';
          } else if (isPetMealsCollection || isProductPage) {
            // Always show on pet-meals and product pages
            icon.style.display = '';
          } else if (hasItems) {
            // Show on other pages when cart has items
            icon.style.display = '';
          } else {
            // Hide on other pages when cart is empty
            icon.style.display = 'none';
          }
        });

        // Reconnect observer after updates are complete
        setTimeout(() => {
          if (observer) {
            startObserver();
          }
          isUpdating = false;
        }, 100);
      })
      .catch(error => {
        console.error('Error updating meal box CTAs:', error);
        isUpdating = false;
      });
  }

  // Update on page load - wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateMealBoxButtons);
  } else {
    updateMealBoxButtons();
  }

  // Update when cart changes (listen for all possible cart events)
  document.addEventListener('ajaxProduct:added', () => {
    setTimeout(updateMealBoxButtons, 100);
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(updateMealBoxButtons, 100);
  });

  document.addEventListener('cart:build', () => {
    setTimeout(updateMealBoxButtons, 100);
  });

  document.addEventListener('cart:built', () => {
    updateMealBoxButtons(); // Immediate update since cart data is available
  });

  document.addEventListener('cart:item-added', () => {
    setTimeout(updateMealBoxButtons, 200);
  });

  // Update when drawer opens or closes
  document.addEventListener('drawerOpen', () => {
    setTimeout(updateMealBoxButtons, 200);
  });

  document.addEventListener('drawerClose', () => {
    setTimeout(updateMealBoxButtons, 200);
    setTimeout(updateMealBoxButtons, 500); // Check again after drawer animation
  });

  // Listen for any form submissions that might add to cart
  document.addEventListener('submit', (e) => {
    if (e.target.matches('form[action*="/cart"]') || e.target.querySelector('[name="add"]')) {
      setTimeout(updateMealBoxButtons, 500);
      setTimeout(updateMealBoxButtons, 1000);
    }
  });

  // Listen for cart changes via Shopify's cart API
  if (window.Shopify && window.Shopify.onCartUpdate) {
    const originalOnCartUpdate = window.Shopify.onCartUpdate;
    window.Shopify.onCartUpdate = function() {
      if (originalOnCartUpdate) originalOnCartUpdate.apply(this, arguments);
      updateMealBoxButtons();
    };
  }

  // Observe cart count changes in the DOM as a fallback
  const startObserver = () => {
    const cartBubble = document.querySelector('.cart-link__bubble-num');
    if (cartBubble && !observer) {
      observer = new MutationObserver(() => {
        if (!isUpdating) {
          updateMealBoxButtons();
        }
      });
      observer.observe(cartBubble, { childList: true, characterData: true, subtree: true });
    }
  };

  // Wait for cart bubble to exist before observing
  const checkForCartBubble = setInterval(() => {
    const cartBubble = document.querySelector('.cart-link__bubble-num');
    if (cartBubble) {
      startObserver();
      clearInterval(checkForCartBubble);
    }
  }, 100);

})();
